import * as React from 'react';

var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFindLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#find-load_svg__clip0_1436_76428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "find-load_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#find-load_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.48-5H-7v78.48h78.48V-5z",
    fill: "#E1EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.278.12H-4.67v76.728h76.948V.12z",
    fill: "#E1EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.796 62.309H-19.35v22.157H2.796V62.309z",
    fill: "#EAB973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.858 58.616L2.785 62.309v22.157l11.073-3.693V58.616z",
    fill: "#D3914F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.35 62.309l11.062-3.693h22.146L2.785 62.309H-19.35z",
    fill: "#F1D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.849 63.72h-7.526v3.251H1.85V63.72z",
    fill: "#E9EBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23 64.028H.085v2.569h.143v-2.569zM.626 64.028H.483v2.569h.143v-2.569zM1.022 64.028H.88v2.569h.143v-2.569z",
    fill: "#606163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.038 58.616l-9.156 3.693h3.823l8.892-3.693h-3.56z",
    fill: "#C08448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.477 44.704H7.104v33.39h33.373v-33.39z",
    fill: "#E5B571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.159 39.138l-16.682 5.566v33.39l16.682-5.567v-33.39z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.104 44.704l16.68-5.566H57.16l-16.682 5.566H7.104z",
    fill: "#ECCF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 43.007v9.303l4.99-1.62v-9.348l-4.99 1.665z",
    fill: "#C07632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 41.342l-.694.232-1.047.341-3.493 1.092h33.605l4.992-1.665H17.184z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.034 46.832H27.707v4.905h11.327v-4.905z",
    fill: "#E4E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.051 47.295h-.22v3.869h.22v-3.87zM29.646 47.295h-.22v3.869h.22v-3.87zM30.24 47.295h-.22v3.869h.22v-3.87zM30.847 47.295h-.22v3.869h.22v-3.87z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87 47.295h-.22v3.869h.22v-3.87zM31.464 47.295h-.22v3.869h.22v-3.87zM32.06 47.295h-.221v3.869h.22v-3.87zM32.666 47.295h-.22v3.869h.22v-3.87zM33.04 47.295h-.22v3.869h.22v-3.87zM33.613 47.295h-.22v3.869h.22v-3.87zM34.197 47.295h-.22v3.869h.22v-3.87zM34.792 47.295h-.22v3.869h.22v-3.87zM35.398 47.295h-.22v3.869h.22v-3.87zM35.993 47.295h-.22v3.869h.22v-3.87z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.014 47.295h-.22v3.869h.22v-3.87zM36.61 47.295h-.22v3.869h.22v-3.87zM37.216 47.295h-.22v3.869h.22v-3.87zM37.811 47.295h-.22v3.869h.22v-3.87z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.147 21.765h-22.3v22.311h22.3V21.765z",
    fill: "#F8C47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.298 18.039l-11.15 3.726v22.3l11.15-3.715V18.04z",
    fill: "#E19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.847 21.765l11.15-3.726h22.3l-11.15 3.726h-22.3z",
    fill: "#FFDF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.465 43.106H28.61v-3.473h6.854v3.473zm-6.765-.1h6.665v-3.284H28.7v3.285z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.574 43.205h-7.062v-3.682h7.062v3.682zm-6.765-.297h6.468V39.82h-6.468v3.087z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58 42.037v-1.323h.298l-.375-.375-.374.375h.297v1.323h.155zM30.418 42.037v-1.323h.309l-.375-.375-.375.375h.298v1.323h.143zM30.517 42.169h-1.18v.1h1.18v-.1zM32.963 40.978c-.033-.363-.374-.639-.804-.639-.43 0-.782.287-.804.64h1.62-.012z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.018 41.033h-1.73v-.055c.033-.385.408-.683.86-.683s.826.298.86.683v.055h.01zm-1.608-.099h1.498c-.055-.308-.375-.54-.75-.54-.374 0-.693.232-.748.54z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.313 42.213s-.099-.022-.132-.055c-.077-.077-.066-.199-.066-.22v-1.004s.022-.044.044-.044.044.022.044.044v1.003s0 .11.044.144c.011.01.033.022.066.022s.044-.011.055-.022c.033-.033.033-.122.022-.144 0-.022.011-.055.044-.055.022 0 .055.011.055.044 0 .011.022.144-.044.22a.177.177 0 01-.12.056l-.012.011z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.313 42.257a.224.224 0 01-.165-.066c-.088-.088-.088-.232-.088-.254v-1.003s.044-.099.099-.099c.055 0 .099.044.099.1v1.002s0 .089.033.11h.033c.011-.021.022-.076.011-.099 0-.022 0-.055.022-.077.011-.022.033-.033.066-.044.055 0 .1.033.11.077 0 .022.023.166-.055.265a.234.234 0 01-.165.077v.011zM34.385 41.772a.564.564 0 01-.563-.562v-.783h1.113v.783a.564.564 0 01-.562.562h.012zm-.463-1.245v.683c0 .253.209.463.463.463.253 0 .462-.21.462-.463v-.684h-.925z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.44 41.728h-.1v.518h.1v-.518z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88 42.202h-.991v.1h.992v-.1z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.189 23.176h-7.57v3.274h7.57v-3.274z",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.512 23.495h-.144v2.58h.144v-2.58zM28.908 23.495h-.143v2.58h.143v-2.58zM29.305 23.495h-.143v2.58h.143v-2.58zM29.712 23.495h-.143v2.58h.143v-2.58z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.724 23.495h-.144v2.58h.144v-2.58zM30.12 23.495h-.143v2.58h.143v-2.58zM30.517 23.495h-.143v2.58h.143v-2.58zM30.924 23.495h-.143v2.58h.143v-2.58zM31.177 23.495h-.143v2.58h.143v-2.58zM31.563 23.495h-.143v2.58h.143v-2.58zM31.949 23.495h-.143v2.58h.143v-2.58zM32.345 23.495h-.143v2.58h.143v-2.58zM32.754 23.495h-.144v2.58h.144v-2.58zM33.15 23.495h-.143v2.58h.143v-2.58z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.16 23.495h-.142v2.58h.143v-2.58zM33.569 23.495h-.143v2.58h.143v-2.58zM33.965 23.495h-.143v2.58h.143v-2.58zM34.362 23.495h-.143v2.58h.143v-2.58z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.291 18.039l-9.222 3.726h3.857l8.946-3.726h-3.58zM23.07 21.765v4.31h3.823l.033-4.31h-3.857zM23.07 39.876v4.31h3.823l.033-4.31h-3.857z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.477 44.704H7.104v33.39h33.373v-33.39zM57.159 39.138l-16.682 5.566v33.39l16.682-5.567v-33.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.104 44.704l16.68-5.566H57.16l-16.682 5.566H7.104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 43.007v9.303l4.99-1.62v-9.348l-4.99 1.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 41.342l-.694.232-1.047.341-3.493 1.092h33.605l4.992-1.665H17.184zM39.034 46.832H27.707v4.905h11.327v-4.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.051 47.295h-.22v3.869h.22v-3.87zM29.646 47.295h-.22v3.869h.22v-3.87zM30.24 47.295h-.22v3.869h.22v-3.87zM30.847 47.295h-.22v3.869h.22v-3.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87 47.295h-.22v3.869h.22v-3.87zM31.464 47.295h-.22v3.869h.22v-3.87zM32.06 47.295h-.221v3.869h.22v-3.87zM32.666 47.295h-.22v3.869h.22v-3.87zM33.04 47.295h-.22v3.869h.22v-3.87zM33.613 47.295h-.22v3.869h.22v-3.87zM34.197 47.295h-.22v3.869h.22v-3.87zM34.792 47.295h-.22v3.869h.22v-3.87zM35.398 47.295h-.22v3.869h.22v-3.87zM35.993 47.295h-.22v3.869h.22v-3.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.014 47.295h-.22v3.869h.22v-3.87zM36.61 47.295h-.22v3.869h.22v-3.87zM37.216 47.295h-.22v3.869h.22v-3.87zM37.811 47.295h-.22v3.869h.22v-3.87zM36.147 21.765h-22.3v22.311h22.3V21.765zM47.298 18.039l-11.15 3.726v22.3l11.15-3.715V18.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.847 21.765l11.15-3.726h22.3l-11.15 3.726h-22.3zM35.465 43.106H28.61v-3.473h6.854v3.473zm-6.766-.1h6.666v-3.284H28.7v3.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.574 43.205h-7.062v-3.682h7.062v3.682zm-6.765-.297h6.468V39.82h-6.468v3.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58 42.037v-1.323h.298l-.375-.375-.374.375h.297v1.323h.155zM30.418 42.037v-1.323h.309l-.375-.375-.375.375h.298v1.323h.143zM30.517 42.169h-1.18v.1h1.18v-.1zM32.963 40.978c-.033-.363-.374-.639-.804-.639-.43 0-.782.287-.804.64h1.62-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.018 41.033h-1.73v-.055c.033-.385.408-.683.86-.683.451 0 .826.298.86.683v.055h.01zm-1.608-.099h1.498c-.055-.308-.375-.54-.75-.54-.374 0-.693.232-.748.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.313 42.213s-.1-.022-.132-.055c-.077-.077-.066-.199-.066-.22v-1.004s.022-.044.044-.044.044.022.044.044v1.003s0 .11.044.144c.011.01.033.022.066.022s.044-.011.055-.022c.033-.033.033-.122.022-.144 0-.022.011-.055.044-.055.022 0 .055.011.055.044 0 .011.022.144-.044.22a.177.177 0 01-.12.056l-.012.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.313 42.257a.225.225 0 01-.165-.066c-.088-.088-.088-.232-.088-.254v-1.003s.044-.099.099-.099c.055 0 .099.044.099.1v1.002s0 .089.033.11h.033c.011-.021.022-.076.011-.099 0-.022 0-.055.022-.077.011-.022.033-.033.066-.044.055 0 .1.033.11.077 0 .022.023.166-.055.265a.234.234 0 01-.165.077v.011zM34.384 41.772a.564.564 0 01-.562-.562v-.783h1.113v.783a.564.564 0 01-.562.562h.011zm-.462-1.245v.683c0 .253.209.463.462.463.254 0 .463-.21.463-.463v-.684h-.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.44 41.728h-.1v.518h.1v-.518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88 42.202h-.991v.1h.991v-.1zM35.188 23.176H27.62v3.274h7.57v-3.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.511 23.495h-.143v2.58h.143v-2.58zM28.908 23.495h-.143v2.58h.143v-2.58zM29.305 23.495h-.143v2.58h.143v-2.58zM29.712 23.495h-.143v2.58h.143v-2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.723 23.495h-.143v2.58h.143v-2.58zM30.12 23.495h-.143v2.58h.143v-2.58zM30.517 23.495h-.143v2.58h.143v-2.58zM30.924 23.495h-.143v2.58h.143v-2.58zM31.177 23.495h-.143v2.58h.143v-2.58zM31.563 23.495h-.143v2.58h.143v-2.58zM31.949 23.495h-.143v2.58h.143v-2.58zM32.345 23.495h-.143v2.58h.143v-2.58zM32.754 23.495h-.144v2.58h.144v-2.58zM33.15 23.495h-.143v2.58h.143v-2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.16 23.495h-.142v2.58h.143v-2.58zM33.569 23.495h-.143v2.58h.143v-2.58zM33.965 23.495h-.143v2.58h.143v-2.58zM34.362 23.495h-.143v2.58h.143v-2.58zM32.291 18.039l-9.222 3.726h3.857l8.946-3.726h-3.58zM23.07 21.765v4.31h3.823l.033-4.31h-3.857zM23.07 39.876v4.31h3.823l.033-4.31h-3.857z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "find-load_svg__clip0_1436_76428"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h65v65H0z"
  })))));
}

export { SvgFindLoad as ReactComponent };
//# sourceMappingURL=find-load.svg.js.map
